module.exports = __webpack_public_path__ + "static/media/Poppins-MediumItalic.9e911c68.ttf";